import React from "react";
import { Modal, Table } from "react-bootstrap";
import PropTypes from "prop-types";

const CodeBlockModal = ({ show, handleClose, comments }) => {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            style={{
                maxWidth: "100%",
                margin: "auto",
                overflowX: "auto"
            }}
            dialogClassName="modal-dialog-scrollable" // Ensures only the body scrolls
        >
            <div
                style={{
                    backgroundColor: "white", // White background for the modal content
                    borderRadius: "8px", // Optional for rounded corners
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>PR Comment Code</Modal.Title>
                </Modal.Header>
                <Modal.Body
                    style={{
                        overflowY: "auto", // Enable vertical scrolling for the body only
                        overflowX: "auto",
                        maxHeight: "70vh", // Limit body height to 60% of viewport height
                    }}
                >
                    {/* Table as the first row */}
                    <Table style={{ marginBottom: "0px" }} responsive striped bordered>
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Comment</th>
                                <th>Reviewer</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comments.map((comment, index) => (
                                <tr key={`${comment.comment}_${index}`}>
                                    <td>{index + 1}</td>
                                    <td>{comment.comment}</td>
                                    <td>{comment.commentAuthor}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    {/* Non-editable multiline code */}
                    <div
                        style={{
                            whiteSpace: "pre-wrap", // Preserve line breaks and spacing
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "10px",
                            backgroundColor: "#f8f9fa",
                            marginTop: "15px",
                            position: "relative"
                        }}
                    >
                        <span className="custom-title">Code Block</span>
                        <br />
                        {comments[0]?.codeBlock || ""}
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    );
};

CodeBlockModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    comments: PropTypes.array.isRequired,
};

export default CodeBlockModal;
